import { render, staticRenderFns } from "./product-pile1.vue?vue&type=template&id=b9129838&"
import script from "./product-pile1.vue?vue&type=script&lang=js&"
export * from "./product-pile1.vue?vue&type=script&lang=js&"
import style0 from "./product-pile1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports